/* 🤖 this file was generated by svg-to-ts */
export const matIconKeyboardBackspace: {
  name: 'keyboard-backspace';
  data: string;
} = {
  name: 'keyboard-backspace',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M21 11H6.83l3.58-3.59L9 6l-6 6 6 6 1.41-1.41L6.83 13H21v-2z"/></svg>`
};
